import { render, staticRenderFns } from "./ProductsStockShortage.vue?vue&type=template&id=3bd21bab&scoped=true&lang=html&"
import script from "./ProductsStockShortage.vue?vue&type=script&lang=js&"
export * from "./ProductsStockShortage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsStockShortage.vue?vue&type=style&index=0&id=3bd21bab&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd21bab",
  null
  
)

export default component.exports